import React from 'react';
import '../styles/Tooltip.css';

// Creative Tooltip Component
const Tooltip = ({ term, description }) => {
  return (
    <div className="tooltip-container" data-description={description}>
      <span className="tooltip-term">{term}</span>
    </div>
  );
};

export default Tooltip; 